// Shares the `.mood` slide-up sheet styling; Mood was just its first user.
export default function HelpSheet({
  open,
  isProFeaturesLocked,
  detachedPanel = false,
  onDetachedPanelChange,
  onResetClick,
  onShortcutsClick,
  onFaqClick,
}) {
  const items = [
    {
      key: "shortcuts",
      label: "Shortcuts",
      onClick: onShortcutsClick,
      enabled: !isProFeaturesLocked,
    },
    { key: "faq", label: "FAQ", onClick: onFaqClick, enabled: true },
    {
      key: "reset",
      label: "Reset Controls",
      title: "Put every control back to its default",
      onClick: onResetClick,
      enabled: true,
    },
    {
      key: "detach",
      // Free for everyone: it only changes where the popup is drawn.
      label: detachedPanel ? "Attach Popup" : "Detach Popup",
      title: detachedPanel
        ? "Go back to the normal extension popup"
        : "Open Slowed as a panel inside the page",
      selected: detachedPanel,
      onClick: () => onDetachedPanelChange?.(!detachedPanel),
      enabled: true,
    },
  ].filter((item) => item.enabled);

  return (
    <div
      id="mood-sheet"
      className={`mood mood--help${open ? " mood--open" : ""}`}
      aria-label="Settings"
      aria-hidden={!open}
      {...(!open ? { inert: true } : {})}
    >
      <div className="mood__header">
        <div className="content__title">Settings</div>
        <p className="mood__subtitle">Shortcuts, answers, and popup options.</p>
      </div>

      <div className="mood__chips-wrap">
        <div className="mood__chips">
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`mood__chip${item.selected ? " mood__chip--selected" : ""}`}
              onClick={() => item.onClick?.()}
              title={item.title || item.label}
              {...(item.selected != null
                ? { "aria-pressed": !!item.selected }
                : {})}
              tabIndex={open ? 0 : -1}
            >
              <span className="mood__chip-name">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
